import React from "react";
import type { EramButtonProps } from "components/buttons/EramButton";
import { useSituationDisplay } from "contexts/sdContext";
import { EramToggleButton } from "components/buttons/EramToggleButton";

export const EramRangeMenuButton = (props: EramButtonProps) => {
  const range = useSituationDisplay().range;
  return <EramToggleButton {...props} overrideText={`RANGE\n${range}`} />;
};
